import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LeafletArcComponent } from './leaflet-arc.component';

@NgModule({
  declarations: [LeafletArcComponent],
	exports: [LeafletArcComponent],
  imports: [
    CommonModule
  ]
})
export class LeafletArcModule { }
